type Result<T> = Record<string, T[]>;

export const allocate = <T>(
    array: T[],
    counts: Record<string, number>,
    isValid: (element: T, key: string) => boolean,
    index: number = 0,
    acc: Result<T> = {},
): Result<T> | undefined => {
    const element = array[index];
    const validKeys = Object.keys(counts).filter((key) => counts[key] && isValid(element, key));

    for (const key of validKeys) {
        const count = counts[key];
        const newCounts = { ...counts };

        if (count === 1) {
            delete newCounts[key];
        } else {
            newCounts[key] = count - 1;
        }

        const newValues = [...(acc[key] || []), element];
        const newAcc = { ...acc, [key]: newValues };

        if (index === array.length - 1) {
            return newAcc;
        }

        const result = allocate(array, newCounts, isValid, index + 1, newAcc);

        if (result) {
            return result;
        }
    }
};
